import { createContext, useContext } from 'react';

// 向导步骤是 renderCredStep(key) 渲染的无参组件，拿不到「这是在替谁填」。步骤里要直接调接口的
// （如 CAQH 检查）从这里取目标 provider：向导代填 = URL 的 providerId、Settings = 当前切到的 provider、
// group review = 选中的 provider；不提供时为 undefined，即登录用户本人
export const CredTargetProviderContext = createContext<number | string | undefined>(undefined);

export const useCredTargetProvider = () => useContext(CredTargetProviderContext);
